<template>
    <div class="welcomeViewApprove">
        <div v-if="componentsList.length">
            <div class="content" v-for="item in componentsList" :key="item.bizItemId" @click="gotoDetail(item)">
                <div class=" head" style=" -webkit-box-orient: vertical;">{{ item.initiatorName }}提交的{{ item.itemName }}
                </div>
                <div class="center" style=" -webkit-box-orient: vertical;">{{ item.bizItemName }}</div>
                <div class="date">{{ $root.formatDate(item.initiateTime) }}</div>
            </div>
        </div>
        <div v-else class="message">暂无消息</div>
        <div class="more" v-if="componentsList.length >= 3">查看更多<i class="el-icon-arrow-right"></i></div>
    </div>
</template>

<script>
export default {
    props: {
        WaitList: {
            type: Array,
            default: () => { return [] }
        },
    },
    data() {
        return {
            componentsList: [],
        }
    },
    methods: {
        gotoDetail(item) {
            let path = '';
            let query = { bizItemId: item.bizItemId };
            switch (item.itemCat) {
                case 'LABOR_APPLY':
                    path = '/common/servicePayDetail'
                    break;
                case 'RISK_ FUND_APPLY':
                    path = '/common/RiskFundDetails'
                    break;
                case 'ADVANCE_TAX_APPLY':
                    path = '/common/refundTaxesDetails'
                    break;
                case 'PAID_MATERIAL_APPLY':
                    path = '/common/materialDetail'
                    break;
                case 'PROPERTY_MANAGEMENT_APPLY':
                    path = '/common/depositDetail'
                    break;
                case 'BID_BOND_APPLY':
                    path = '/common/marginDetail'
                    break;
                case 'SEAL_APPLY':
                    path = '/cm/sealApplicationDetail'
                    break;
                case 'CONTRACT_APPLY':
                    path = '/cm/contract/read_view0'
                    break;
                case 'GUARANTEE_LETTER_APPLY':
                    path = '/commonPage/projectManage/guaranteeDetail'
                    break;
                case 'INSURANCE_APPLY':
                    path = '/finance/insuranceDetail'
                    break;
                case 'PUNISHMENT_APPLY':
                    path = '/common/adminSanctionDetail'
                    break;
                case 'LITIGATION_APPLY':
                    path = '/common/litigationDetail'
                    break;
                case 'COMPLAINT_APPLY':
                    path = '/common/complaintDetail'
                    break;
                case 'PROJECT_APPLY':
                    path = '/common/proPreparationDetail'
                    break;
                case 'CASUALTY_APPLY':
                    path = '/common/injuriesDetail'
                    break;
                case 'CREDIT_APPLY':
                    path = '/common/creditDetail'
                    break;
                case 'PROJECT_LOSE_SINGLE':
                    path = '/commonPage/projectManage/losingDetailNew'
                    break;
                case 'PROJECTMANAGER_APPLY'://精英库人员详情
                    path = '/cd/pm/edit'
                    break;
                case 'ADVANCETAXAPPLY_APPLY'://预缴税费
                    path = '/fm/prepaidTaxDetail'
                    break;
                case 'INVOICEAPPLYDATA_APPLY'://消项票
                    path = '/fm/FmOutPutTicketDetail'
                    break;
                case 'INVOICEAPPLYDATA_VOID'://作废
                    path = '/fm/FMVoidRecordDetail'
                    break;
                case 'INVOICEAPPLYDATA_REDRUSH'://红冲
                    path = '/fm/FMVoidRecordDetail'
                    query = { bizItemId: item.bizItemId, type: 3, applyType: 3 }
                    break;
                case 'COMPLETION_SETTLE_APPLY'://完工结算
                    path = '/cm/CMFinishedAccountDetail'
                    query = { bizItemId: item.bizItemId }
                    break;
                case 'OTHER_SEAL_APPLY':
                    path = '/cm/sealApplicationOtherDetail'
                    query = { bizItemId: item.bizItemId }
                    break;
                case 'TICKET_RECORDS':
                    path = '/admin/WorkOrderDetail'
                    query = { bizItemId: item.bizItemId }
                    break;
            }
            if (!path) return;
            this.$router.push({ path: path, query: query });
        },
    },
    watch: {
        WaitList(value) {
            this.componentsList = value
            console.log(value)
        },
    }
}
</script>

<style lang="scss" scoped>
.welcomeViewApprove {
    .content {
        margin-bottom: 15px;
        cursor: pointer;
        box-sizing: border-box;
        border: 1px solid #fff;

        .head {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 4px;
            letter-spacing: 1px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
        }

        .center {
            color: #ccc;
            margin-bottom: 3px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
        }

        .date {
            color: #ccc;
        }

        // &:hover {
        //     border-color: red;
        // }

        // &:last-child {
        //     margin-bottom: 0px;
        // }
    }

    .message {
        text-align: center;
        margin-top: 92px;
        font-size: 16px;
    }

    .more {
        color: #71a0f5;
        font-size: 14px;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// welcomeViewApprove.vue?7db1196f